import dayjs, { Dayjs } from 'dayjs';
import * as React from 'react';
import { useCallback, useMemo } from 'react';
import 'dayjs/locale/ru' // import locale
import * as weekday from 'dayjs/plugin/weekday'
import './HireCalendar.scss';
import { ArrowLeft, ArrowRight } from '@finam/web-ui-kit/Icons/Arrow';
import cn from 'classnames'
import { start } from 'repl';
import { IRecruitmentDateSlot } from '../../Services/ResponseData';
import { Body16 } from '@finam/web-ui-kit/Typography/Typography.styles';

var weekdayPlug = require('dayjs/plugin/weekday')
dayjs.extend(weekdayPlug);
dayjs.locale('ru');

interface IProps {
    value?: IRecruitmentDateSlot,
    onSelect: (val: IRecruitmentDateSlot | undefined) => void,
    freeSlots: IRecruitmentDateSlot[],
    isMobile?: boolean
}

export const HireCalendar: React.FC<IProps> = props => {
    const getFirstSlotDate = (slots: IRecruitmentDateSlot[]): Date => {
        if (!slots || slots.length < 1)
            return today;
        else {
            var firsSlot = slots.sort((a, b) => a.slotDate.getTime() - b.slotDate.getTime())[0];
            return firsSlot.slotDate;
        }
    }

    const today: Date = dayjs().toDate();
    const [startDate, setStartDate] = React.useState<Date>(props.value ? dayjs(props.value.slotDate).toDate() : getFirstSlotDate(props.freeSlots));
    const [dateMobile, setDateMobile] = React.useState<Date>();

    const firstDayOfTheMonth: Dayjs = useMemo<Dayjs>(
        () => dayjs(startDate).startOf('month'),
        [startDate]
    );

    const firstDayOfFirstWeekOfMonth: Dayjs = useMemo(
        () => dayjs(firstDayOfTheMonth).startOf("week"),
        [firstDayOfTheMonth]
    );

    const generateFirstDayOfEachWeek = useCallback((day: Dayjs): Dayjs[] => {
        const dates: Dayjs[] = [];
        let date = day.clone();
        do {
            dates.push(date);
            date = date.clone().add(1, "week");
        } while (date.month() == startDate.getMonth());
        return dates;
    }, [startDate]);

    const generateWeek = useCallback((day: Dayjs): Date[] => {
        const dates: Date[] = [];
        for (let i = 0; i < 7; i++) {
            const date = day.clone().add(i, "day").toDate();
            dates.push(date);
        }
        return dates;
    }, [firstDayOfFirstWeekOfMonth]);

    const generateWeeksOfTheMonth = useMemo((): Date[][] => {
        const firstDayOfEachWeek = generateFirstDayOfEachWeek(
            firstDayOfFirstWeekOfMonth
        );
        return firstDayOfEachWeek.map((date) => generateWeek(date));
    }, [generateFirstDayOfEachWeek, firstDayOfFirstWeekOfMonth, generateWeek, startDate]);

    const generateCalendarHeader: JSX.Element[] = useMemo(
        (): JSX.Element[] => {
            return Array.from(Array(7).keys()).map(i => dayjs().weekday(i).format("dd")).map((h, hi) => <th key={`dayOfWeek_${hi}`}>{h}</th>)
        }, undefined);

    const GetSlots: (date: Date) => IRecruitmentDateSlot[] = date => {
        const daySlots = props.freeSlots.filter((sl, index, self) =>
            sl.slotDate.toISOString() == date.toISOString());
        const slots = daySlots.filter((d, i, self) => { return self.findIndex(j => j.time == d.time) == i });
        return slots || [];
    };


    const generateDayJSX = (day: Date, index: number): JSX.Element | null => {
        let slotsDivs: JSX.Element | undefined = undefined;
        let slots = [];
        if (day >= today) {
            slots = GetSlots(day);
            if (slots.length > 0 && !props.isMobile)
                slotsDivs = <div className='slotWrap'>
                    {slots.map((slot, i) =>
                        <div key={`slot_${i}`} onClick={() => props.onSelect(slot)} className={cn("slot", { "active": slot == props.value })}>{slot.time}</div>)}
                </div>
        }
        return <td
            className={cn({ "anotherMonth": !sameMonth(day, startDate), "availableDate": slots.length > 0, "selected": props.value?.slotDate.getTime() == day.getTime() || dateMobile?.getTime() == day.getTime() })}
            key={`day_${index}`}
            onClick={_ => {
                if (!!props.isMobile && slots.length > 0) {
                    props.onSelect(undefined);
                    setDateMobile(day);
                }
            }}
        >
            <div className='dateCircleWrapper'><div className='dateCircle'>{day.getDate()}</div>{slotsDivs}</div>
        </td>;
    };

    const generateMobileSlots = (): JSX.Element | null => {
        const date = props.value?.slotDate || dateMobile;
        const slots = !!date ? GetSlots(date) : [];
        if (slots.length > 0)
            return <div className='slotWrapMobile'>
                {slots.map((slot, i) =>
                    <div key={`slot_${i}`} onClick={() => props.onSelect(slot)} className={cn("slotMobile", { "active": slot == props.value })}>{slot.time}</div>)}
            </div>
        else
            return null;
    }


    const sameMonth: (date1: Date, date2: Date) => boolean =
        (date1, date2) => date1.getMonth() == date2.getMonth() && date1.getFullYear() == date2.getFullYear()



    return <div>
        <div className='monthSelectWrapper'>
            <div className='monthSelect'>
                <div className="arrow" onClick={() => setStartDate(dayjs(startDate).add(-1, "month").toDate())}>
                    <ArrowLeft />
                </div>
                <span className='monthName'>{dayjs(startDate).format('MMMM')}</span>
                <div className="arrow" onClick={() => setStartDate(dayjs(startDate).add(1, "month").toDate())}>
                    <ArrowRight />
                </div>
            </div>
        </div>
        {props.isMobile && (!!props.value || !!dateMobile) && <div className='mobileSlotSelectWrapper'>
            <div>
                <Body16><b>Важно!</b> Обратите внимание что слоты выбираются по <span style={{color: 'red', fontWeight:'bold'}}>московскому</span> времени</Body16>
                <h5>Дата выхода</h5>
                {<h3>{dayjs(!!props.value?.slotDate ? props.value.slotDate : dateMobile).format("DD.MM.YYYY")}</h3>}
                <div>
                    {generateMobileSlots()}
                </div>
            </div>
        </div>}
        <table className='hireDateCalendar'>
            <thead>
                <tr>
                    {generateCalendarHeader}
                </tr>
            </thead>
            <tbody>
                {generateWeeksOfTheMonth.map((week, wi) => <tr key={`week_${wi}`}>
                    {week.map((day, di) => generateDayJSX(day, di))}
                </tr>)}</tbody>
        </table>

    </div>
} 